import BaseApiClient from '../BaseApiClient';
import {
  DashboardNewVsWonStatInterface,
  DashboardInsuranceStatInterface
} from '@interfaces/DashboardStats.interface';
import type { CashflowResponse } from '@/interfaces/Cashflow.interface';

export class ApiDashboard extends BaseApiClient {
  async getTasksNewVsWonStats(interval: string): Promise<{
    items: DashboardNewVsWonStatInterface[];
    total: DashboardNewVsWonStatInterface;
  }> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/dashboard-stats/task-new-vs-won?interval=${interval}`)
        .then((res) => {
          if (res.data) {
            resolve({ items: res.data.data, total: res.data.total });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getInsuranceOverviewStats(interval: string): Promise<{
    items: DashboardInsuranceStatInterface[];
    total: DashboardInsuranceStatInterface;
  }> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/dashboard-stats/insurance-overview?interval=${interval}`)
        .then((res) => {
          if (res.data) {
            resolve({ items: res.data.data, total: res.data.total });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getCashflow(): Promise<CashflowResponse> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/dashboard-stats/cashflow', {
          headers: {
            Version: '2025-11-14'
          }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { dashboardQueryKeys } from './query-keys';
export {
  useDashboardCashflowQuery,
  useDashboardInsuranceOverviewQuery,
  useDashboardTasksNewVsWonQuery
} from './use-dashboard-queries';
